'use strict';

requirejs.config({
	baseUrl: '/wwwroot/js',
	paths: {
		'knockout': 'app/libs/libs',
		'knockout.mapping': 'app/libs/libs',
		'knockout.validation': 'app/libs/libs',
		'knockout-fast-foreach': 'app/libs/libs',
		'text': 'app/libs/custom/requirejs-text/text',
		'jquery': 'app/libs/libs',
		'trumbowyg': 'app/libs/libs',
		'jsonTree': 'app/libs/libs',
		'moment': 'app/libs/libs',
		'moment-timezone': 'app/libs/custom/moment-timezone/moment-timezone',
		'moment-duration-format': 'app/libs/custom/moment-duration-format/moment-duration-format',
		'grapnel': 'app/libs/libs',
		'jszip': 'app/libs/libs',
		'QRCode': 'app/libs/libs',
		'@microsoft/signalr': 'app/libs/libs',
		'underscore': 'app/libs/libs',
		'devextreme': 'app/libs/libs',
		'app': './app',
		'providers': './app/providers',
		'hubs': './app/hubs',
		'services': './app/services',
		'controllers': './app/controllers',
		'componentLoaders': './app/componentLoaders',
		'ui': './app/ui',
		'widgets': './app/widgets',
		'configuration': './app/configuration',
		'viewModels': './app/viewModels',
		'routing': './app/routing',
		'models': './app/models',
		'messenger': './app/messenger',
		'helpers': './app/helpers',
		'components': './app/components',
		'scriptLoaders': './app/scriptLoaders',
		'language': './app/language',
		'store': './app/store',
		'app/setup/devExtreme': 'app/libs/libs',
		'wasm': './app/wasm', // the wasm library
		'wasmbin': './app/wasm/glue'
	},
	shim: {
		wasmbin: {
			init: function init() {
				return wasm_bindgen;
			}
		}
	}
});

define('jQuery', ['jquery'], function ($) {
	return $;
});
define("app/require.config", function(){});

